import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";

// css
import styles from "./Auth.module.scss";

// img
import logo from "../../Assets/images/logo.png";

const AuthLayout = () => {
  return (
    <>
      <section
        className={`${styles.authLayout} authLayout position-relative py-3 d-flex align-items-center justify-content-center flex-column`}
        style={{ zIndex: "9" }}
      >
        <Container className="">
          <Row className="justify-content-center">
            <Col lg="11" className="my-2">
              <div
                className={`${styles.formWrpper} formWrpper `}
                style={{ background: "#FBFBFB", height: "90vh" }}
              >
                <Row className="h-100">
                  <Col
                    lg="6"
                    className={`${styles.imgWrpper} ${styles.logo}  d-lg-flex align-items-center justify-content-center h-100`}
                  >
                    <img src={logo} alt="" className="img-fluid" />
                  </Col>
                  <Col lg="6" className="my-2 py-4 h-100">
                    <Outlet />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AuthLayout;
